"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RARITY = exports.ITEM_TYPE = exports.ITEM_ID = exports.getQteFromRarity = void 0;
var RARITY;
(function (RARITY) {
    RARITY["COMMUN"] = "c";
    RARITY["UNCOMMUN"] = "u";
    RARITY["RARE"] = "r";
    RARITY["EPIC"] = "e";
    RARITY["LEGENDARY"] = "l";
})(RARITY || (exports.RARITY = RARITY = {}));
var ITEM_ID;
(function (ITEM_ID) {
    ITEM_ID["BEER"] = "beer";
    ITEM_ID["CHAINSAW"] = "chainsaw";
    ITEM_ID["RUSTED_CHAINSAW"] = "rusted-chainsaw";
    ITEM_ID["DRUG"] = "drug";
    ITEM_ID["GREEN_PILL"] = "green-pill";
    ITEM_ID["NEWSPAPER"] = "newspaper";
    ITEM_ID["BOOSTER"] = "booster";
    ITEM_ID["ENERGY_GEL"] = "energy-gel";
    ITEM_ID["SMELLING_SALTS"] = "smelling-salts";
    ITEM_ID["SPIKED_CLEATS"] = "spiked-cleats";
    ITEM_ID["IRON_BRACER"] = "iron-bracer";
})(ITEM_ID || (exports.ITEM_ID = ITEM_ID = {}));
var ITEM_TYPE;
(function (ITEM_TYPE) {
    ITEM_TYPE["CONSUMABLE"] = "consumable";
    ITEM_TYPE["WEAPON"] = "weapon";
    ITEM_TYPE["FILE"] = "file";
})(ITEM_TYPE || (exports.ITEM_TYPE = ITEM_TYPE = {}));
const getQteFromRarity = (rarity) => {
    if (rarity === RARITY.COMMUN) {
        return 10000;
    }
    if (rarity === RARITY.UNCOMMUN) {
        return 1000;
    }
    if (rarity === RARITY.RARE) {
        return 100;
    }
    if (rarity === RARITY.EPIC) {
        return 10;
    }
    if (rarity === RARITY.LEGENDARY) {
        return 1;
    }
};
exports.getQteFromRarity = getQteFromRarity;
